'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const GiftIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.2001 11.2V20.2C19.2001 20.8 18.8 21.2 18.2 21.2H5.80005C5.20005 21.2 4.80005 20.7 4.80005 20.2V11.2M12 7.69996L8.50005 6.79996C7.00005 6.39996 6.50005 4.49996 7.60005 3.29996C8.70005 2.19996 10.7 2.69996 11.1 4.19996L12 7.69996ZM12 7.69996L12.9 4.19996C13.3 2.69996 15.3 2.19996 16.4 3.29996C17.5 4.49996 17 6.39996 15.5 6.79996L12 7.69996ZM12 7.69996V21.2M21.2001 11.2H2.80005V8.69996C2.80005 8.09996 3.20005 7.69996 3.80005 7.69996H20.3C20.9 7.69996 21.3 8.09996 21.3 8.69996V11.2H21.2001Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpGiftIcon = forwardRef(GiftIcon);

export { VpGiftIcon as default };
